// 判断密码是否含有特殊字符
function validateUserPassword (rule: any, value: string, callback: any) {
    var reg = /^([0-9]|[a-zA-Z]){6,16}$/;
    if ((value !== "" && reg.test(value) === false) || (value !== ""&&(value.length < 6||value.length>16))) {
        callback(new Error('格式不正确，必须为6-16位的英文或数字，且不能包含特殊字符'));
    } else {
        callback();
    }
}
// 验证手机号
function validateMobile (rule:any, value:string, callback:any) {
    value = value.trim();
    if (value !== "") {
        if (value.length === 11) {
            callback();
        } else {
            callback(new Error('手机号格式不正确'));
        }
    } else {
        callback();
    }
}

// 验证社会信用码
function validateInfoCode (rule:any, value:string, callback:any) {
    value = value.trim();
    let reg = new RegExp("^([0-9A-HJ-NPQRTUWXY]{2}\\d{6}[0-9A-HJ-NPQRTUWXY]{10}|[1-9]\\d{14})$");
    if (value !== "") {
        // && (value.length === 13 || value.length === 15 || value.length === 18)
        if (!reg.test(value)) {
            callback(new Error('社会信用码格式不正确'));
        } else {
            callback();
        }
    } else {
        callback();
    }
}

/**
 * 判断是否是数字
 */
function checkNumber (rule:any, value:string, callback:any) {
    let reg = new RegExp("^\\d+$");
    let reg2 = new RegExp("^((-\\d+)|(0+))$");
    if (value !== ""&&!reg.test(value) && !reg2.test(value)) {
        callback(new Error('请输入数字'));
    }else {
        callback();
    }
}

/**
 * 判断数据推送地址是否已http或https 开头
 */
 function checkUrl (rule:any, value:string, callback:any) {
    let reg = new RegExp("^(http|https)://");
    // let reg2 = new RegExp("/^(https:\/\/)/i");
    if (value !== ""&& !reg.test(value)) {
        callback(new Error('请输入http或https开头的接口地址'));
    }else {
        callback();
    }
}

export {
    validateUserPassword,
    validateMobile,
    validateInfoCode,
    checkNumber,
    checkUrl
}